import { render, staticRenderFns } from "./StudioBookingJagdschule.vue?vue&type=template&id=19dcb335&"
import script from "./StudioBookingJagdschule.vue?vue&type=script&lang=js&"
export * from "./StudioBookingJagdschule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports